// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"502c9059","455":"18ebe911","977":"fac3cd3b"}[chunkId] + ".chunk.js";
};